function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.155 6.714h-2.988a.845.845 0 01-.834-.857c0-.473.373-.857.834-.857h5c.46 0 .833.384.833.857V11a.845.845 0 01-.833.857.845.845 0 01-.834-.857V7.926l-6.494 6.68a.817.817 0 01-1.178 0l-3.578-3.68-5.66 5.823a.817.817 0 01-1.179 0 .875.875 0 010-1.212l6.25-6.429a.817.817 0 011.179 0l3.577 3.68 5.905-6.074z"
});

var SvgTrendingUp = function SvgTrendingUp(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/trending-up.3f6c76d0.svg";
export { SvgTrendingUp as ReactComponent };